<template>
    <div class="top-menu-container">
        <!-- <a-menu v-model="activeMenu"
                mode="horizontal"
                @select="selectedMenuHandle">
            <template v-for="item in menuTreeData">
                <a-menu-item :key="item.id"><span>{{item.title}}</span></a-menu-item>
            </template>
        </a-menu> -->
        <div id="navScroller">
            <ul class="navScroller-ul ul-hover">
                <li class="dropdown"
                    @mouseenter="enterLi('catalogue')"
                    @mouseleave="leveLi('catalogue')"
                    :class="{'active-li':navigation === 'catalogue'}"
                    style="padding: 0 35px 0 0">
                    <a href="javascript: void(0)"
                       class="dropdown-toggle"
                       role="button"
                       aria-haspopup="true"
                       aria-expanded="false">服务目录
                    </a>
                    <div v-if="navigation === 'catalogue'"
                         class="dropdown-menu header-menu-ul menu-detail-container"
                         :style="{width:headerWidth+'px' }">
                        <div>
                            <div class="menu-left">
                                <ul>
                                    <li :class="{'left-active':subNavigation === 'cloudCompute'}"
                                        @mouseenter="entersubLi('cloudCompute')"><span class="left-li">云计算基础</span></li>
                                    <li :class="{'left-active':subNavigation === 'develpServer'}"
                                        @mouseenter="entersubLi('develpServer')"><span class="left-li">云计算高阶</span></li>
                                    <!-- <li :class="{'left-active':subNavigation === 'dataServer'}"
                                        @mouseenter="entersubLi('dataServer')"><span class="left-li">云数据服务</span></li> -->
                                    <!-- <li :class="{'left-active':subNavigation === 'operationServer'}"
                                        @mouseenter="entersubLi('operationServer')"><span class="left-li">云运维服务</span></li> -->
                                    <!-- <li :class="{'left-active':subNavigation === 'operateServer'}"
                                        @mouseenter="entersubLi('operateServer')"><span class="left-li">云运营服务（对内）</span></li> -->
                                    <li :class="{'left-active':subNavigation === 'mgtSynergyServer'}"
                                        @mouseenter="entersubLi('mgtSynergyServer')"><span class="left-li">管理协同服务（待建）</span></li>
                                    <li :class="{'left-active':subNavigation === 'mgtEmpowerServer'}"
                                        @mouseenter="entersubLi('mgtEmpowerServer')"><span class="left-li">管理赋能服务（待建）</span></li>
                                    <li :class="{'left-active':subNavigation === 'mgtRisServer'}"
                                        @mouseenter="entersubLi('mgtRisServer')"><span class="left-li">风险管理服务（待建）</span></li>
                                    <li :class="{'left-active':subNavigation === 'dataAnalysisServer'}"
                                        @mouseenter="entersubLi('dataAnalysisServer')"><span class="left-li">数据分析服务（待建）</span></li>
                                </ul>
                            </div>
                            <div class="menu-right">
                                <div class="column-list-box"
                                     v-if="subNavigation === 'cloudCompute'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">计算服务</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/Fqrxkgr_o7.html"><span>X86弹性云服务器</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/FsuUAJ2WU.html"><span>ARM弹性云服务器</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/abRjar61W.html"><span>X86高性能版弹性云服务器</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/EFAn4e9Cz.html"><span>镜像服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/KC0LzrDqR.html"><span>裸金属服务</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">存储服务</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/eF9lyBLXZ.html"><span>云硬盘
                                                            通用型</span></a></li>
                                                <li><a href="https://portal.cdxccloud.com/details/yrH7iYjrn.html"><span>云硬盘
                                                            性能型</span></a></li>
                                                <li><a href="https://portal.cdxccloud.com/details/LYvlQztIX.html"><span>云硬盘备份</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/GolrtPi3I.html"><span>云服务器备份</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/QKO2LvGFh.html"><span>云快照服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/SjGk0uZ3c.html"><span>对象存储服务</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">数据库服务</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/eTaFsQBV4.html"><span>MySQL数据库-单机模式</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/33BIXB4yQ.html"><span>MySQL数据库-主备模式</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/e9i_20ImE.html"><span>MySQL数据库-集群模式</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/Gl_edzd6Y.html"><span>Redis缓存-单机模式</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/AR22rJSH7.html"><span>Redis缓存-集群模式</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/DSSkw4Xu7.html"><span>达梦数据库</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">网络服务</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/EYEJgg-lq.html"><span>弹性IP服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/1FbQlRi_u.html"><span>弹性公网带宽服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/3nwi81fVL.html"><span>NAT网关服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/zoGYL2BsL.html"><span>私有网络</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/a05ogxAUy.html"><span>访问控制服务</span></a>
                                                </li>
                                                <!-- <li><a href="/details/0hLuoHOTJ.html"><span>网络ACL服务</span></a>
                                                                    </li> -->
                                                <li><a href="https://portal.cdxccloud.com/details/CFiEC28Cq.html"><span>VPC终端节点服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/ugKKIrf3h.html"><span>ELB弹性负载均衡服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/M54KZc5_5.html"><span>基础型云专线服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/Z2SKTXnQP.html"><span>增强型云专线服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/9YAzVS7OV.html"><span>云域名解析服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/Qa1uL1d8x.html"><span>云连接服务</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">安全服务</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/s9zWaTc3O.html"><span>Web应用防火墙WAF</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/Fg7obcTyz.html"><span>云日志审计服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/xHzk33qXM.html"><span>云防火墙服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/gSaDETscl.html"><span>云数据库审计服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/7LArdR6m_.html"><span>云边界防火墙服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/EY8rGcOQ2.html"><span>云主机安全服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/rYDQQSxmr.html"><span>云漏洞扫描服务</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/eDjcLYQaZ.html"><span>云堡垒机服务</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">操作系统</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/cABhcsgIR.html"><span>麒麟V10</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/2NNHRREgb.html"><span>Open
                                                            Euler</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">中间件</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/MF4Gq1Tx5.html"><span>国产东方通TongWeb</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">容器</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/JRydso8mk.html"><span>云容器引擎CCE</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="column-list-box"
                                     v-if="subNavigation === 'develpServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">门户平台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/7DrAF5Ybc.html"><span>统一登录平台</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">开发者平台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/_b2rUW1_x.html"><span>代码开发平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/L1MVYEtPF.html"><span>物联网平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/l1-UB0I_E.html"><span>物联设备接入服务</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">数据中台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/oY_ZhDgCU.html"><span>数据开发治理平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/2cN6SUUpX.html"><span>数据可视化平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/xvSMKom4p.html"><span>主数据平台</span></a>
                                                </li>
                                                <!-- <li><a href=""><span>主数据平台接入服务</span></a>
                                                                    </li> -->
                                                <li><a href="https://portal.cdxccloud.com/details/31t5t0TJJ.html"><span>数据仓库平台</span></a>
                                                </li>
                                                <!-- <li><a href=""><span>大数据平台</span></a>
                                                                    </li> -->
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">技术中台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/ici1gsw_h.html"><span>微服务平台</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">运维平台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/nw6mnn97M.html"><span>IT服务工单平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/i2N6B34jJ.html"><span>统一监控平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/3t4ojQnkz.html"><span>信息资产统计平台</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">集成平台</span>
                                            <ul>
                                                <!-- <li><a href="/details/qJayci8l_.html"><span>企业数据总线</span></a>
                                                                    </li> -->
                                                <li><a href="https://portal.cdxccloud.com/details/cbUY_N5Y9.html"><span>企业服务总线-应用集成</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="column-list-box"
                                     v-if="subNavigation === 'dataServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">数据平台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/oY_ZhDgCU.html"><span>数据开发治理平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/2cN6SUUpX.html"><span>数据可视化平台</span></a>
                                                </li>
                                                <!-- <li><a href="#"><span>主数据平台</span></a></li>
                                                <li><a href="#"><span>数据仓库平台</span></a></li> -->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="column-list-box"
                                     v-if="subNavigation === 'operationServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">运维平台</span>
                                            <ul>
                                                <li><a href="https://portal.cdxccloud.com/details/nw6mnn97M.html"><span>IT服务工单平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/3t4ojQnkz.html"><span>信息资产统计平台</span></a>
                                                </li>
                                                <li><a href="https://portal.cdxccloud.com/details/i2N6B34jJ.html"><span>统一监控平台</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="column-list-box"
                                     v-if="subNavigation === 'operateServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">运营平台</span>
                                            <ul>
                                                <li><a href="#"><span>云管平台管理员</span></a></li>
                                                <li><a href="#"><span>统一门户管理员</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="column-list-box"
                                     v-if="subNavigation === 'mgtSynergyServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">资产管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>资产管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">投资管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>投资管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">战略绩效管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>战略绩效管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">资源系统平台</span>
                                            <ul>
                                                <li><a href="#"><span>B端/G端资源管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">采购管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>兴城e采系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="column-list-box"
                                     v-if="subNavigation === 'mgtEmpowerServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">人力资源类系统</span>
                                            <ul>
                                                <li><a href="#"><span>人力资源管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">档案管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>档案管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">数字化办公类系统</span>
                                            <ul>
                                                <li><a href="#"><span>数字化办公底座及OA系统</span></a></li>
                                                <li><a href="#"><span>印章管理系统</span></a></li>
                                                <li><a href="#"><span>差旅系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">财务管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>财务管理系统升级</span></a></li>
                                                <li><a href="#"><span>全面预算管理系统</span></a></li>
                                                <li><a href="#"><span>费控系统</span></a></li>
                                                <li><a href="#"><span>财务共享咨询服务</span></a></li>
                                                <li><a href="#"><span>财务共享系统</span></a></li>
                                                <li><a href="#"><span>税务管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="column-list-box"
                                     v-if="subNavigation === 'mgtRisServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">安全环保管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>安全环保管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">审计与纪检管理系统</span>
                                            <ul>
                                                <li><a href="#"><span>审计与纪检管理系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">法务系统</span>
                                            <ul>
                                                <li><a href="#"><span>法务系统</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="column-list-box"
                                     v-if="subNavigation === 'dataAnalysisServer'">
                                    <div class="column-list-item">
                                        <div>
                                            <span class="header-three">决策支撑平台</span>
                                            <ul>
                                                <li><a href="#"><span>决策支撑平台</span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li role="presentation"
                    @mouseenter="enterLi('option')"
                    @mouseleave="leveLi"
                    :class="{'active-li':navigation === 'option'}"
                    style="padding: 0 35px 0 0">
                    <a role="menuitem"
                       tabindex="-1"
                       href="https://portal.cdxccloud.com/cmscase___SkCL09aCb">{{'解决方案'}}</a>
                </li>
                <li role="presentation"
                    @mouseenter="enterLi('server')"
                    @mouseleave="leveLi"
                    :class="{'active-li':navigation === 'server'}"
                    style="padding: 0 35px 0 0">
                    <a role="menuitem"
                       tabindex="-1"
                       href="https://portal.cdxccloud.com/support___HyVhxcjAE">{{'支持与服务'}}</a>
                </li>
                <li role="presentation"
                    @mouseenter="enterLi('cloud')"
                    @mouseleave="leveLi"
                    :class="{'active-li':navigation === 'cloud'}"
                    style="padding: 0 35px 0 0">
                    <a role="menuitem"
                       tabindex="-1"
                       href="https://portal.cdxccloud.com/aboutus___jpk-DZ38c">{{'了解兴城云'}}</a>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
// import qs from 'qs'
export default {
    name: 'topMenuComponents',
    // props: ['headerWidth'],
    data () {
        return {
            menuselectedDirKeys: [],
            menuTreeData: [],
            activeMenu: [],
            navigation: '',
            subNavigation: 'cloudCompute',
            hasCookie: '',
            headerWidth: 1920
        }
    },
    computed: {
        restUrl () {
            return this.$store.state.restUrl
        }
    },
    created () {
        // 初始化数据
        this.initData()
    },
    methods: {
        enterLi (value) {
            const headWith = this.$emit('getDocHeaderWith')
            this.headerWidth = headWith.$el.parentNode.parentNode.scrollWidth
            this.navigation = value
        },
        entersubLi (value) {
            this.subNavigation = value
        },
        leveLi () {
            this.navigation = ''
        },
        selectedMenuHandle () {
            console.log(this.activeMenu, 'activeMenu')
        },
        async initData () {
            // await fetch(this.restUrl + '/list').then(response => response.json()).then(result => {
            //     this.dbData = result
            //     // 处理数据
            //     this.menuTreeData = this.parseData()
            // })
            this.menuTreeData = [
                {
                    title: '服务目录',
                    parentId: '0',
                    position: 'top',
                    zIndex: '1',
                    id: 'catalogue'
                },
                {
                    title: '解决方案',
                    parentId: '0',
                    position: 'top',
                    zIndex: '1',
                    id: 'option'
                },
                {
                    title: '支持与服务',
                    parentId: '0',
                    position: 'top',
                    zIndex: '1',
                    id: 'server'
                },
                {
                    title: '了解兴城云',
                    parentId: '0',
                    position: 'top',
                    zIndex: '1',
                    id: 'cloud'
                }
            ]
        },
        // 初始化tree数据
        parseData () {
            const cloneData = JSON.parse(JSON.stringify(this.dbData))
            return cloneData.filter((father, index) => {
                return father.parentId === '0' && father.position === 'top'
            })
        }
    }
}
</script>
<style lang="less">
.top-menu-container {
    .ant-menu-horizontal {
        line-height: 53px;
        border-bottom: 0px;
        > .ant-menu-item-active {
            border-bottom: 0px !important;
            &:hover {
                border-bottom: 2px solid #c7000a !important;
            }
        }
        > .ant-menu-item {
            border-bottom: 0px !important;
            &:hover {
                color: #333 !important;
                border-bottom: 2px solid #c7000a !important;
            }
        }
    }
    .ant-menu-item-selected {
        color: #c7000a !important;
    }
}
</style>
<style lang="less" scoped>
.top-menu-container {
    // border: 1px solid red;
    width: 100%;
    height: 100%;
}

#navScroller {
    ul {
        padding-left: 0 !important;
        li {
            padding-right: 35px;
            // display: inline-block;
            height: 68px;
            position: relative;
            list-style: none !important;
            font-size: 15px !important;
        }
    }
    .navScroller-ul {
        > li {
            display: inline-block;
        }
    }
}
// #navScroller > ul > li {
//     height: 68px;
//     position: relative;
//     list-style: none !important;
// }

#navScroller > ul.ul-hover > li::before {
    content: '';
    width: 0;
    height: 2px;
    background: #c7000a;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: width 0.5s;
}

#navScroller > ul.ul-hover > li.active-li::before {
    width: calc(100% - 35px);
    transition: width 0.5s;
}

#navScroller > ul.ul-active > li::after {
    content: '';
    width: calc(100% - 35px);
    height: 2px;
    background: transparent;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: color 0.5s;
}

#navScroller > ul.ul-active > li.active-li::after {
    background: #c7000a;
    transition: color 0.5s;
}

#navScroller > ul > li.active-li > a {
    /* color: #c7000a; */
}

#navScroller > ul > li > a {
    color: #333;
}

#navScroller > ul > li:hover > a {
    /* color: #c7000a !important;
        font-weight: bold; */
}
.menu-detail-container {
    z-index: 10000;
    position: absolute;
    left: -250px;
    top: 68px;
    // width: 100vw;
    padding: 0;
    background: transparent;
    border-radius: 0;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.menu-detail-container > div {
    padding: 0;
    display: flex;
    height: 100%;
}

.menu-detail-container .menu-left {
    width: 250px;
    height: 550px;
    // padding-right: 16px;
    padding-left: 20px;
    overflow-y: auto;
    background-color: #fff;
    padding-top: 20px;
    display: flex;
    justify-content: center;
    background-repeat: no-repeat;
    background-image: url('./../../assets/img/left-bg.png');
    background-size: cover;
}

/* // 自定义滚动条 */
.menu-detail-container .menu-right::-webkit-scrollbar,
.menu-detail-container .menu-left::-webkit-scrollbar {
    width: 6px;
    max-height: 50px;
    border-radius: 50%;
    margin-right: 16px;
}

/* // 定义滚动条轨道 */
.menu-detail-container .menu-left::-webkit-scrollbar-track,
.menu-detail-container .menu-right::-webkit-scrollbar-track {
    background-color: transparent !important;
    /* // display: none; */
}

/* // 内轨道部分 */
.menu-detail-container .menu-left::-webkit-scrollbar-thumb,
.menu-detail-container .menu-right::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #d7d7d7 !important;
}

.menu-detail-container .menu-left::-webkit-scrollbar-thumb:hover,
.menu-detail-container .menu-right::-webkit-scrollbar-thumb:hover {
    cursor: pointer;
    /* background-color: #365466 !important; */
}

.menu-detail-container .menu-left > ul > li {
    color: #333;
    width: 100%;
    font-size: 16px;
    height: 46px !important;
    line-height: 46px !important;
    padding: 0 !important;
}

.menu-detail-container .menu-left > ul > li > .left-li {
    color: #333;
    font-size: 16px;
    height: 46px !important;
    line-height: 46px !important;
    display: inline-block;
    cursor: pointer;
    position: relative;
}

.menu-detail-container .menu-left > ul > li > .left-li::after {
    content: '';
    width: 0;
    height: 2px;
    background: #c7000a;
    position: absolute;
    bottom: 0px;
    left: 0;
    transition: width 0.5s;
}

.menu-detail-container .menu-left > ul > li.left-active > .left-li::after {
    width: 100%;
    transition: width 0.5s;
}

.menu-detail-container .menu-left li.left-active .left-li {
    color: #c7000a;
    font-weight: bold;
}

.menu-detail-container .menu-right {
    width: calc(100% - 250px);
    /* height: 100%; */
    height: 550px;
    overflow-y: auto;
    padding-top: 20px;
    background-color: rgba(255, 255, 255, 0.95);
}

.menu-detail-container .menu-right .column-list-box {
    // display: none;
    display: flex;
    flex-wrap: wrap;
}

.menu-detail-container .menu-right .column-list-box:first-child {
    display: flex;
}

.menu-detail-container .menu-right .column-list-item {
    /* margin-bottom: 10px;
        width: 25%; */
    /* box-sizing: border-box;
        break-inside: avoid; */
    flex: 1;
    padding-left: 55px;
}

.menu-detail-container .menu-right .column-list-item > div {
    height: 100%;
    /* background: #4286F5; */
    box-sizing: border-box;
    /* padding: 15px 0 0 0; */
    margin: 0 0 45px 0;
}

.menu-detail-container .menu-right .column-list-item .header-three {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    line-height: 35px;
    display: inline-block;
}

.menu-detail-container .menu-right .column-list-item > div > ul {
    margin-top: 15px;
}

.menu-detail-container .menu-right .column-list-item > div > ul > li {
    width: 100%;
    line-height: 28px !important;
    height: 28px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-bottom: 10px;
}

.menu-detail-container .menu-right .column-list-item > div > ul > li:first-child {
    /* margin-top: 15px; */
}

.menu-detail-container .menu-right .column-list-item > div > ul > li > a:hover {
    background: transparent !important;
}

.menu-detail-container .menu-right .column-list-item > div > ul > li span {
    color: #545b61;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
}

.menu-detail-container .menu-right .column-list-item > div > ul > li:hover span {
    color: #c7000a;
    text-decoration: underline;
    cursor: pointer;
}
</style>
